import styled, { css } from 'styled-components/macro'

interface WrapperProps {
    size: 'big' | 'small'
}

export const Wrapper = styled.div<WrapperProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: ${({ theme }) => theme.colors.grayscale_0};
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.secondary_500};

    ${({ theme, size }) =>
        size === 'big'
            ? css`
                  width: 32px;
                  height: 32px;
                  font-size: ${theme.textVariants.bodyLargeStrong
                      .fontSizeMobile}px;
                  line-height: ${theme.textVariants.bodyLargeStrong
                      .lineHeightMobile}px;
              `
            : css`
                  width: 24px;
                  height: 24px;
                  font-size: ${theme.textVariants.bodySmall.fontSizeMobile}px;
                  line-height: ${theme.textVariants.bodySmall
                      .lineHeightMobile}px;
              `}
`
